import Hls from 'hls.js'
import { gsap } from 'gsap/all'
import { Magnetic } from '../../src/js/parts/magnetic.js'
import { store } from '../../src/js/core/store.js'

export const initVideo = () => {
  const videos = [...document.querySelectorAll('.js-video')]
  if (videos.length <= 0) { return false }

  videos.forEach(video => {
    new Video(video)
  })
}

class Video {
  constructor (video) {
    this.video = video
    this.src = this.video.getAttribute('data-src')
    this.parent = video.parentElement
    this.poster = this.parent.querySelector('.js-poster')
    this.playTrigger = video.closest('.js-play-video')
    this.playButton = this.parent.querySelector('.js-play-button')
    this.noLoop = this.video.classList.contains('js-video-no-loop') ? true : false
    this.init()
  }

  bind = () => {
    window.addEventListener('resize', this.resize)
    this.parent.addEventListener('mouseenter', this.handleEnter)
    this.parent.addEventListener('mouseleave', this.handleLeave)
    if (this.playTrigger) {
      this.playTrigger.addEventListener('click', this.play)
    }
  }

  resize = () => {
    this.parentRect = this.parent.getBoundingClientRect()
    this.scale = (this.parentRect.width + 20) / this.parentRect.width
  }

  handleEnter = () => {
    gsap.to(this.poster, { duration: 0.5, scale: this.scale, ease: 'power2.out' })
  }

  handleLeave = () => {
    gsap.to(this.poster, { duration: 0.5, scale: 1, ease: 'power2.out' })
  }

  startLoop = () => {
    this.looping = true

    this.tweenPoster()
    this.videoInterval = setInterval(() => {
      if (this.video.currentTime > 6 && this.looping) {
        this.video.currentTime = 0
      }
    }, 100)
  }

  play = () => {
    if (this.looping) { this.playInitial() }
  }

  playInitial = () => {
    const promise = this.video.play()

    if (promise !== undefined) {
      promise.then(_ => {
        this.looping = false
        this.video.currentTime = 0
        this.video.muted = false
        this.video.controls = true
        this.video.style.pointerEvents = 'all'
        this.playButton.style.display = 'none'
      })
    }
  }

  tweenPoster () {
    gsap.to(this.poster, {
      duration: 0.5,
      opacity: 0,
      ease: 'power4.out',
      onComplete: () => {
        this.poster.remove()
      }
    })
  }

  attach () {
    if (Hls.isSupported()) {
      this.hls = new Hls({
        maxMaxBufferLength: 4,
        startLevel: 3
      })

      this.hls.attachMedia(this.video)
      this.hls.loadSource(this.src)

      this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
        this.isLoaded = true
        if (!this.noLoop) {
          this.startLoop()
        }
      })
    } else if (this.video.canPlayType('application/vnd.apple.mpegurl')) {
      this.video.src = this.src

      this.video.addEventListener('loadedmetadata', () => {
        this.isLoaded = true
        if (!this.noLoop) {
          this.startLoop()
        }
      })
    }
  }

  createMagneticButton () {
    this.wrapper = this.video.closest('.video-wrapper')
    this.button = this.video.parentNode.querySelector('.play-button')
    new Magnetic(this.wrapper, this.button)
  }

  init () {
    this.bind()
    this.resize()
    this.attach()

    if (!store.isDevice) {
      this.createMagneticButton()
    } else {
      this.button = this.video.parentNode.querySelector('.play-button')
      this.button.style.left = `50%`
      this.button.style.top = `50%`
      this.button.style.transform = `translate(-50%, -50%)`
    }
  }
}
